import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import findResourceInCourseOutline from 'legacy-src/utility/helpers/findResourceInCourseOutline';
import { getTopicQuestionsFilter } from 'legacy-packages/unit-outline/src/components/_shared/util';

const TopicQuestionCreateAction = (props) => {
  const {
    router,
    params: { subject: subjectId },
    units,
    item: { id },
    isPreApSubject,
    widgetTagColumn,
    unitsLabel,
    location,
    subunitLabel,
  } = props;
  let { searchTerm } = location.query;
  searchTerm = searchTerm || null;

  const addQuestionsToQuiz = () => {
    const coResource = findResourceInCourseOutline(id, units);
    const { unit, subunitMetadata: metadata, subunitTitle } = coResource;
    const { number: unitNumber } = unit;

    const topicQuestionsFilter = isPreApSubject
      ? metadata
      : getTopicQuestionsFilter({
          subjectId: parseInt(subjectId, 10),
          unitNumber,
          metadata,
          widgetTagColumn,
          skipCustomFilters: false,
          unitTitle: unit.title,
          unitsLabel,
          subunitLabel,
        });

    let query = {};
    if (searchTerm) {
      query.searchTerm = searchTerm;
    }

    router.push({
      pathname: `/${subjectId}/question_bank/create/auto-build/filters`,
      query,
      state: {
        topicQuestionsFilter,
        quizTitle: `${searchTerm || subunitTitle} Quiz`,
      },
    });
  };

  return (
    <ButtonWithIcon
      isIcon
      isNaked
      icon="add"
      tabIndex={0}
      aria-label="Create Quiz"
      onClick={addQuestionsToQuiz}
    />
  );
};

TopicQuestionCreateAction.propTypes = {
  router: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  units: PropTypes.array.isRequired,
  item: PropTypes.object.isRequired,
  isPreApSubject: PropTypes.bool,
  widgetTagColumn: PropTypes.string,
  unitsLabel: PropTypes.string,
  subunitLabel: PropTypes.string,
};

TopicQuestionCreateAction.defaultProps = {
  isPreApSubject: false,
  widgetTagColumn: null,
  unitsLabel: null,
  subunitLabel: null,
};

export default withRouter(TopicQuestionCreateAction);
